import React from "react";
import { Route, Routes,Navigate } from "react-router-dom";
// import Layout from "../layout";
import {  isUserAuthenticated } from "../utils/auth";
import UserRoutes from "../users/routes/UserRoutes";

function MainUserRoutes() {

  return (  
      <Routes>

        {/* User Home Route */}
        <Route path="/*" element={isUserAuthenticated() ? <UserRoutes /> : <Navigate to="/user/login" />} />
      </Routes>
  );
}

export default MainUserRoutes;
